/**
 * Parses firstIncompleteIndex to extract section index
 * Handles both number and string formats (e.g., "0-0" for card sections)
 */
export function parseFirstIncompleteIndex(firstIncompleteIndex: string | number): number {
  if (typeof firstIncompleteIndex === 'number') {
    return firstIncompleteIndex;
  }

  if (typeof firstIncompleteIndex === 'string') {
    const sectionIndex = parseInt(firstIncompleteIndex.split('-')[0], 10);
    return !isNaN(sectionIndex) && sectionIndex >= 0 ? sectionIndex : 0;
  }

  return 0;
}
